import React from 'react';
import styled from '@emotion/styled';

const Info = styled.div`
  text-align: center;
  padding: 25px;
  background: #4694ce;
`;

const Icon = styled.svg`
  width: 70px;
  height: 70px;

  path {
    fill: #daeaf5;
  }
`;

const Name = styled.h5`
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 15px;
  margin-top: 15px;
  padding: 0;
  user-select: none;
`;

const Role = styled.p`
  color: #fff;
  padding: 0;
  margin: 0;
  user-select: none;
  font-size: 0.85rem;
`;

interface Props {
  userName: string;
  userRole: string;
}

const UserHeader = (props: Props) => {
  const { userName, userRole } = props;
  return (
    <Info>
      <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125 125">
        <path d="M62.5,114.58A52,52,0,0,1,22.14,95.36c1.35-3.06,4.08-5.18,9.72-6.49,11.69-2.7,23.22-5.11,17.67-15.34C33.11,43.23,44.86,26,62.5,26c17.3,0,29.34,16.55,13,47.49C70.07,83.7,81.19,86.12,93.13,88.88c5.64,1.3,8.39,3.41,9.74,6.46A52,52,0,0,1,62.5,114.58ZM62.5,0A62.5,62.5,0,1,0,125,62.5,62.5,62.5,0,0,0,62.5,0Z" />
      </Icon>
      <Name>{userName}</Name>
      <Role>{userRole}</Role>
    </Info>
  );
};

export { UserHeader, UserHeader as default };
